import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getCreators } from '../services/api';
import { toast } from 'sonner';

function CreatorsListPage() {
  const [creators, setCreators] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchCreators() {
      try {
        const res = await getCreators(50);
        setCreators(res.data);
      } catch (error) {
        console.error('Error fetching creators:', error);
        toast.error('Failed to load creators');
      } finally {
        setLoading(false);
      }
    }
    fetchCreators();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-16 h-16 border-4 border-hot-rod border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen pb-24 pt-8 page-padding" data-testid="creators-list-page">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-teko mb-4">Creators</h1>
        <p className="text-text-secondary mb-12">Discover talented comic creators on Supremics</p>

        {creators.length === 0 ? (
          <div className="text-center py-12 border border-border">
            <p className="text-text-secondary">No creators found</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {creators.map((creator) => (
              <Link 
                key={creator.id}
                to={'/creator/' + creator.id}
                className="card-hotrod p-6 flex items-center gap-4"
                data-testid={'creator-item-' + creator.id}
              >
                <div className="w-20 h-20 rounded-full overflow-hidden border-2 border-chrome-orange flex-shrink-0">
                  <img 
                    src={creator.profile_picture || 'https://images.unsplash.com/photo-1649331593153-7575e5cd3c6e?w=100'} 
                    alt={creator.username}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-teko text-2xl truncate">{creator.username}</h3>
                  <p className="text-sm text-text-secondary line-clamp-2">{creator.bio || 'Comic Creator'}</p>
                  <div className="flex items-center gap-3 mt-2">
                    <span className="text-xs text-text-secondary">{creator.comic_count} comics</span>
                    <span className={creator.subscription_tier === 'contributor' ? 'badge-contributor' : 'badge-creator'}>
                      {creator.subscription_tier}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default CreatorsListPage;
